<template>
    <div class="dropdown2" v-el:dropdown :style="getStyle()">
        <slot></slot>
    </div>
</template>
<style>
    .dropdown2 {
        position: absolute;
        font-weight: 400;
        z-index: 99
    }
</style>
<script>
    const $ = require('jquery')
    const utils = require('sci/utils')

    export default {
        name: 'ui-dropdown2',
        props: {},
        init () {
            this.$anchor = null
        },
        data () {
            return {
                visible: false,
                top: 0,
                left: 0
            }
        },
        methods: {
            move (anchor) {
                this.$anchor = anchor

                const { top, left, width, height } = utils.getBounds(anchor)

                this.top = top
                this.left = left
            },
            toggle (anchor) {
                if (this.visible) {
                    this.hide()
                } else {
                    this.show(anchor)
                }
            },
            show (anchor) {
                this.visible = true
                this.move(anchor)

                this.createEvent()
            },
            hide () {
                this.visible = false

                this.destroyEvent()
            },
            getStyle () {
                const style = {}

                style.top = (this.top + 10) + 'px'
                style.left = this.left + 'px'

                // if (this.position === 'right') {
                //     style.right = 0
                //     style.left = 'auto'
                // } else {
                //     style.top = this.top
                //     style.left = this.left
                // }

                if (this.visible) {
                    style.display = 'block'
                } else {
                    style.display = 'none'
                }

                return style
            },
            createEvent () {
                this.destroyEvent()
                document.documentElement.addEventListener('click', this.bodyClicked)
                window.addEventListener('scroll', this.bodyScrolled, true)
            },
            destroyEvent () {
                document.documentElement.removeEventListener('click', this.bodyClicked)
                window.removeEventListener('scroll', this.bodyScrolled, true)
            },
            bodyScrolled (e) {
                if (!utils.isElementInViewport(this.$anchor)) {
                    this.hide()
                } else {
                    this.move(this.$anchor)
                }
            },
            bodyClicked (e) {
                if (this.$anchor && (this.$anchor === e.target || this.$anchor.contains(e.target))) {
                    return
                }

                const parent = this.$parent

                if (parent.constructor.name === 'RemoteDropdown') {
                    if (!parent.$el.contains(e.target)) {
                        this.hide()
                    }
                } else {
                    if (!this.$els.dropdown.contains(e.target)) {
                        this.hide()
                    }
                }
            }
        },
        ready () {
            this.$newEl = this.$appendTo(document.body).$el
        },
        destroyed () {
            document.body.removeChild(this.$newEl)
        },
        beforeDestroy () {
            this.destroyEvent()
        },
    }
</script>



// WEBPACK FOOTER //
// Dropdown2.vue?15a40aa2